import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'button-novo-veiculo',
  templateUrl: './button-novo-veiculo.component.html',
  styleUrls: ['./button-novo-veiculo.component.scss']
})
export class ButtonNovoVeiculoComponent implements OnInit {

  constructor(
    private _router: Router,
    private _route: ActivatedRoute
  ) { }

  @Input() tpConcessao;

  ngOnInit() {
  }

  click($event) {
    this._router.routeReuseStrategy.shouldReuseRoute = () => false
    this._router.navigate(['atendimento','coletivorural','gerenciar',
    this._route.snapshot.params['cdConcessao'],'veiculo','novo']).then(() => {
    });
  }

}
